/* This file is auto-generated with figma-svg. */
import hoc from '@hh.ru/magritte-ui-icon/hoc';
import { CheckmarkOutlinedCircledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/product/CheckmarkOutlinedCircledSize16';
import { CheckmarkOutlinedCircledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/product/CheckmarkOutlinedCircledSize24';
import { CheckmarkOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/product/CheckmarkOutlinedSize16';
import { CheckmarkOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/product/CheckmarkOutlinedSize24';
import { ChevronArrowDiagonalUpRightFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/product/ChevronArrowDiagonalUpRightFilledSize16';
import { ChevronArrowDiagonalUpRightFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/product/ChevronArrowDiagonalUpRightFilledSize24';
import { ChevronArrowDownRightFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/product/ChevronArrowDownRightFilledSize16';
import { ChevronArrowDownRightFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/product/ChevronArrowDownRightFilledSize24';
import { ChevronArrowRightFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/product/ChevronArrowRightFilledSize16';
import { ChevronArrowRightFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/product/ChevronArrowRightFilledSize24';
import { ChevronGroup1FilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/product/ChevronGroup1FilledSize16';
import { ChevronGroup1FilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/product/ChevronGroup1FilledSize24';
import { ChevronGroup2FilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/product/ChevronGroup2FilledSize16';
import { ChevronGroup2FilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/product/ChevronGroup2FilledSize24';
import { ChevronGroup3FilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/product/ChevronGroup3FilledSize16';
import { ChevronGroup3FilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/product/ChevronGroup3FilledSize24';
import { CompanysLifeFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/product/CompanysLifeFilledSize16';
import { CompanysLifeFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/product/CompanysLifeFilledSize24';
import { CompanysLifeOutlinedCircledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/product/CompanysLifeOutlinedCircledSize16';
import { CompanysLifeOutlinedCircledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/product/CompanysLifeOutlinedCircledSize24';
import { CompanysLifeOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/product/CompanysLifeOutlinedSize16';
import { CompanysLifeOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/product/CompanysLifeOutlinedSize24';
import { DreamjobCircledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/product/DreamjobCircledSize16';
import { DreamjobCircledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/product/DreamjobCircledSize24';
import { DreamjobSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/product/DreamjobSize16';
import { DreamjobSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/product/DreamjobSize24';
import { EmployersRatingFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/product/EmployersRatingFilledSize16';
import { EmployersRatingFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/product/EmployersRatingFilledSize24';
import { EmployersRatingOutlinedCircledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/product/EmployersRatingOutlinedCircledSize16';
import { EmployersRatingOutlinedCircledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/product/EmployersRatingOutlinedCircledSize24';
import { EmployersRatingOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/product/EmployersRatingOutlinedSize16';
import { EmployersRatingOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/product/EmployersRatingOutlinedSize24';
import { HrBrandOutlinedCircledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/product/HrBrandOutlinedCircledSize16';
import { HrBrandOutlinedCircledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/product/HrBrandOutlinedCircledSize24';
import { HrBrandOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/product/HrBrandOutlinedSize16';
import { HrBrandOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/product/HrBrandOutlinedSize24';
import { ItAccreditationCircledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/product/ItAccreditationCircledSize16';
import { ItAccreditationCircledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/product/ItAccreditationCircledSize24';
import { ItAccreditationFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/product/ItAccreditationFilledSize16';
import { ItAccreditationFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/product/ItAccreditationFilledSize24';
import { ItAccreditationSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/product/ItAccreditationSize16';
import { ItAccreditationSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/product/ItAccreditationSize24';
import { LabelEyeFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/product/LabelEyeFilledSize16';
import { LabelEyeFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/product/LabelEyeFilledSize24';
import { LabelFlameFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/product/LabelFlameFilledSize16';
import { LabelFlameFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/product/LabelFlameFilledSize24';
import { LabelThumbFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/product/LabelThumbFilledSize16';
import { LabelThumbFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/product/LabelThumbFilledSize24';
import { LabelUserFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/product/LabelUserFilledSize16';
import { LabelUserFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/product/LabelUserFilledSize24';
import { OvalSplitFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/product/OvalSplitFilledSize16';
import { OvalSplitFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/product/OvalSplitFilledSize24';
import { QuestionFilledSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/product/QuestionFilledSize16';
import { QuestionFilledSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/product/QuestionFilledSize24';

export const ChevronGroup1FilledSize16 = /* #__PURE__*/ hoc<'ChevronGroup1FilledSize16'>(
    ChevronGroup1FilledSize16Glyph,
    'ChevronGroup1FilledSize16'
);
export const EmployersRatingOutlinedSize16 = /* #__PURE__*/ hoc<'EmployersRatingOutlinedSize16'>(
    EmployersRatingOutlinedSize16Glyph,
    'EmployersRatingOutlinedSize16'
);
export const EmployersRatingOutlinedSize24 = /* #__PURE__*/ hoc<'EmployersRatingOutlinedSize24'>(
    EmployersRatingOutlinedSize24Glyph,
    'EmployersRatingOutlinedSize24'
);
export const ItAccreditationSize16 = /* #__PURE__*/ hoc<'ItAccreditationSize16'>(
    ItAccreditationSize16Glyph,
    'ItAccreditationSize16'
);
export const ChevronGroup2FilledSize16 = /* #__PURE__*/ hoc<'ChevronGroup2FilledSize16'>(
    ChevronGroup2FilledSize16Glyph,
    'ChevronGroup2FilledSize16'
);
export const LabelFlameFilledSize16 = /* #__PURE__*/ hoc<'LabelFlameFilledSize16'>(
    LabelFlameFilledSize16Glyph,
    'LabelFlameFilledSize16'
);
export const EmployersRatingOutlinedCircledSize24 = /* #__PURE__*/ hoc<'EmployersRatingOutlinedCircledSize24'>(
    EmployersRatingOutlinedCircledSize24Glyph,
    'EmployersRatingOutlinedCircledSize24'
);
export const LabelThumbFilledSize16 = /* #__PURE__*/ hoc<'LabelThumbFilledSize16'>(
    LabelThumbFilledSize16Glyph,
    'LabelThumbFilledSize16'
);
export const QuestionFilledSize24 = /* #__PURE__*/ hoc<'QuestionFilledSize24'>(
    QuestionFilledSize24Glyph,
    'QuestionFilledSize24'
);
export const DreamjobSize24 = /* #__PURE__*/ hoc<'DreamjobSize24'>(DreamjobSize24Glyph, 'DreamjobSize24');
export const CompanysLifeFilledSize16 = /* #__PURE__*/ hoc<'CompanysLifeFilledSize16'>(
    CompanysLifeFilledSize16Glyph,
    'CompanysLifeFilledSize16'
);
export const OvalSplitFilledSize16 = /* #__PURE__*/ hoc<'OvalSplitFilledSize16'>(
    OvalSplitFilledSize16Glyph,
    'OvalSplitFilledSize16'
);
export const CompanysLifeOutlinedCircledSize16 = /* #__PURE__*/ hoc<'CompanysLifeOutlinedCircledSize16'>(
    CompanysLifeOutlinedCircledSize16Glyph,
    'CompanysLifeOutlinedCircledSize16'
);
export const ChevronGroup2FilledSize24 = /* #__PURE__*/ hoc<'ChevronGroup2FilledSize24'>(
    ChevronGroup2FilledSize24Glyph,
    'ChevronGroup2FilledSize24'
);
export const LabelEyeFilledSize24 = /* #__PURE__*/ hoc<'LabelEyeFilledSize24'>(
    LabelEyeFilledSize24Glyph,
    'LabelEyeFilledSize24'
);
export const ChevronArrowDownRightFilledSize24 = /* #__PURE__*/ hoc<'ChevronArrowDownRightFilledSize24'>(
    ChevronArrowDownRightFilledSize24Glyph,
    'ChevronArrowDownRightFilledSize24'
);
export const LabelUserFilledSize16 = /* #__PURE__*/ hoc<'LabelUserFilledSize16'>(
    LabelUserFilledSize16Glyph,
    'LabelUserFilledSize16'
);
export const CompanysLifeOutlinedCircledSize24 = /* #__PURE__*/ hoc<'CompanysLifeOutlinedCircledSize24'>(
    CompanysLifeOutlinedCircledSize24Glyph,
    'CompanysLifeOutlinedCircledSize24'
);
export const ChevronArrowDownRightFilledSize16 = /* #__PURE__*/ hoc<'ChevronArrowDownRightFilledSize16'>(
    ChevronArrowDownRightFilledSize16Glyph,
    'ChevronArrowDownRightFilledSize16'
);
export const LabelThumbFilledSize24 = /* #__PURE__*/ hoc<'LabelThumbFilledSize24'>(
    LabelThumbFilledSize24Glyph,
    'LabelThumbFilledSize24'
);
export const ItAccreditationFilledSize16 = /* #__PURE__*/ hoc<'ItAccreditationFilledSize16'>(
    ItAccreditationFilledSize16Glyph,
    'ItAccreditationFilledSize16'
);
export const DreamjobSize16 = /* #__PURE__*/ hoc<'DreamjobSize16'>(DreamjobSize16Glyph, 'DreamjobSize16');
export const CompanysLifeFilledSize24 = /* #__PURE__*/ hoc<'CompanysLifeFilledSize24'>(
    CompanysLifeFilledSize24Glyph,
    'CompanysLifeFilledSize24'
);
export const LabelFlameFilledSize24 = /* #__PURE__*/ hoc<'LabelFlameFilledSize24'>(
    LabelFlameFilledSize24Glyph,
    'LabelFlameFilledSize24'
);
export const CompanysLifeOutlinedSize24 = /* #__PURE__*/ hoc<'CompanysLifeOutlinedSize24'>(
    CompanysLifeOutlinedSize24Glyph,
    'CompanysLifeOutlinedSize24'
);
export const ChevronArrowRightFilledSize24 = /* #__PURE__*/ hoc<'ChevronArrowRightFilledSize24'>(
    ChevronArrowRightFilledSize24Glyph,
    'ChevronArrowRightFilledSize24'
);
export const LabelEyeFilledSize16 = /* #__PURE__*/ hoc<'LabelEyeFilledSize16'>(
    LabelEyeFilledSize16Glyph,
    'LabelEyeFilledSize16'
);
export const CompanysLifeOutlinedSize16 = /* #__PURE__*/ hoc<'CompanysLifeOutlinedSize16'>(
    CompanysLifeOutlinedSize16Glyph,
    'CompanysLifeOutlinedSize16'
);
export const CheckmarkOutlinedCircledSize16 = /* #__PURE__*/ hoc<'CheckmarkOutlinedCircledSize16'>(
    CheckmarkOutlinedCircledSize16Glyph,
    'CheckmarkOutlinedCircledSize16'
);
export const ChevronGroup3FilledSize24 = /* #__PURE__*/ hoc<'ChevronGroup3FilledSize24'>(
    ChevronGroup3FilledSize24Glyph,
    'ChevronGroup3FilledSize24'
);
export const HrBrandOutlinedCircledSize16 = /* #__PURE__*/ hoc<'HrBrandOutlinedCircledSize16'>(
    HrBrandOutlinedCircledSize16Glyph,
    'HrBrandOutlinedCircledSize16'
);
export const HrBrandOutlinedCircledSize24 = /* #__PURE__*/ hoc<'HrBrandOutlinedCircledSize24'>(
    HrBrandOutlinedCircledSize24Glyph,
    'HrBrandOutlinedCircledSize24'
);
export const CheckmarkOutlinedCircledSize24 = /* #__PURE__*/ hoc<'CheckmarkOutlinedCircledSize24'>(
    CheckmarkOutlinedCircledSize24Glyph,
    'CheckmarkOutlinedCircledSize24'
);
export const ChevronArrowRightFilledSize16 = /* #__PURE__*/ hoc<'ChevronArrowRightFilledSize16'>(
    ChevronArrowRightFilledSize16Glyph,
    'ChevronArrowRightFilledSize16'
);
export const ChevronGroup3FilledSize16 = /* #__PURE__*/ hoc<'ChevronGroup3FilledSize16'>(
    ChevronGroup3FilledSize16Glyph,
    'ChevronGroup3FilledSize16'
);
export const ItAccreditationSize24 = /* #__PURE__*/ hoc<'ItAccreditationSize24'>(
    ItAccreditationSize24Glyph,
    'ItAccreditationSize24'
);
export const ItAccreditationFilledSize24 = /* #__PURE__*/ hoc<'ItAccreditationFilledSize24'>(
    ItAccreditationFilledSize24Glyph,
    'ItAccreditationFilledSize24'
);
export const EmployersRatingOutlinedCircledSize16 = /* #__PURE__*/ hoc<'EmployersRatingOutlinedCircledSize16'>(
    EmployersRatingOutlinedCircledSize16Glyph,
    'EmployersRatingOutlinedCircledSize16'
);
export const ChevronArrowDiagonalUpRightFilledSize24 = /* #__PURE__*/ hoc<'ChevronArrowDiagonalUpRightFilledSize24'>(
    ChevronArrowDiagonalUpRightFilledSize24Glyph,
    'ChevronArrowDiagonalUpRightFilledSize24'
);
export const OvalSplitFilledSize24 = /* #__PURE__*/ hoc<'OvalSplitFilledSize24'>(
    OvalSplitFilledSize24Glyph,
    'OvalSplitFilledSize24'
);
export const ChevronArrowDiagonalUpRightFilledSize16 = /* #__PURE__*/ hoc<'ChevronArrowDiagonalUpRightFilledSize16'>(
    ChevronArrowDiagonalUpRightFilledSize16Glyph,
    'ChevronArrowDiagonalUpRightFilledSize16'
);
export const QuestionFilledSize16 = /* #__PURE__*/ hoc<'QuestionFilledSize16'>(
    QuestionFilledSize16Glyph,
    'QuestionFilledSize16'
);
export const LabelUserFilledSize24 = /* #__PURE__*/ hoc<'LabelUserFilledSize24'>(
    LabelUserFilledSize24Glyph,
    'LabelUserFilledSize24'
);
export const EmployersRatingFilledSize16 = /* #__PURE__*/ hoc<'EmployersRatingFilledSize16'>(
    EmployersRatingFilledSize16Glyph,
    'EmployersRatingFilledSize16'
);
export const EmployersRatingFilledSize24 = /* #__PURE__*/ hoc<'EmployersRatingFilledSize24'>(
    EmployersRatingFilledSize24Glyph,
    'EmployersRatingFilledSize24'
);
export const ItAccreditationCircledSize24 = /* #__PURE__*/ hoc<'ItAccreditationCircledSize24'>(
    ItAccreditationCircledSize24Glyph,
    'ItAccreditationCircledSize24'
);
export const ItAccreditationCircledSize16 = /* #__PURE__*/ hoc<'ItAccreditationCircledSize16'>(
    ItAccreditationCircledSize16Glyph,
    'ItAccreditationCircledSize16'
);
export const DreamjobCircledSize16 = /* #__PURE__*/ hoc<'DreamjobCircledSize16'>(
    DreamjobCircledSize16Glyph,
    'DreamjobCircledSize16'
);
export const HrBrandOutlinedSize16 = /* #__PURE__*/ hoc<'HrBrandOutlinedSize16'>(
    HrBrandOutlinedSize16Glyph,
    'HrBrandOutlinedSize16'
);
export const HrBrandOutlinedSize24 = /* #__PURE__*/ hoc<'HrBrandOutlinedSize24'>(
    HrBrandOutlinedSize24Glyph,
    'HrBrandOutlinedSize24'
);
export const DreamjobCircledSize24 = /* #__PURE__*/ hoc<'DreamjobCircledSize24'>(
    DreamjobCircledSize24Glyph,
    'DreamjobCircledSize24'
);
export const ChevronGroup1FilledSize24 = /* #__PURE__*/ hoc<'ChevronGroup1FilledSize24'>(
    ChevronGroup1FilledSize24Glyph,
    'ChevronGroup1FilledSize24'
);
export const CheckmarkOutlinedSize24 = /* #__PURE__*/ hoc<'CheckmarkOutlinedSize24'>(
    CheckmarkOutlinedSize24Glyph,
    'CheckmarkOutlinedSize24'
);
export const CheckmarkOutlinedSize16 = /* #__PURE__*/ hoc<'CheckmarkOutlinedSize16'>(
    CheckmarkOutlinedSize16Glyph,
    'CheckmarkOutlinedSize16'
);
